import { render, staticRenderFns } from "./kline.vue?vue&type=template&id=4487154e&scoped=true"
import script from "./kline.vue?vue&type=script&lang=js"
export * from "./kline.vue?vue&type=script&lang=js"
import style0 from "./kline.vue?vue&type=style&index=0&id=4487154e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4487154e",
  null
  
)

export default component.exports